import { taxInquires } from './TaxInquiry/index';
import { taxFee } from './TaxFee/index';
import { taxComments } from './comments/index';
import { taxInquiryTabs } from './TaxInquiryTabs/index';
import { taxRollAdjustments } from './Adjustments/index';
import { MortgageCoProcessing } from './MortgageCoProcessing/index';
import { trWorkFile } from './trWorkFile/index';
import { taxCommon } from './TaxCommon/index';
import { taxPayment } from './payments/index';
import { taxWarrants } from './TaxWarrants/index';
import { taxProtests } from './TaxProtests/index';
import { ccPayments } from './ccPayments/index';
import { commonImport } from './CommonImport/index';
import { taxCheckRecon } from './checkRecon/index';
import { taxPstPeriod } from './postingPeriod/index';
import { taxExemptMfg } from './TaxInquiry/TaxExemptMfg';
import { newTaxroll } from './NewTaxroll/index';
import { tifDistricts } from './tifDistricts/index';
import { juneResale } from './juneResale/index';
import { commissionersSale } from './commissionersSale/index';

export const tax = {
  namespaced: true,
  modules: {
    taxInquires,
    taxFee,
    taxComments,
    taxInquiryTabs,
    taxRollAdjustments,
    MortgageCoProcessing,
    trWorkFile,
    taxCommon,
    taxPayment,
    taxWarrants,
    taxProtests,
    ccPayments,
    commonImport,
    taxCheckRecon,
    taxPstPeriod,
    taxExemptMfg,
    newTaxroll,
    tifDistricts,
    juneResale,
    commissionersSale,
  },
};

export default tax;
